import { CUSTOM_APP } from "@nx/mono-common";

export interface LmwUserExists {
  userExists: boolean;
  userVerified: boolean
  registeredOnLmw?: boolean;
  attributes?: { "custom:app": string; }
}

export function userUnverifiedViaLMW(lmwUserExists: LmwUserExists): boolean {
  return lmwUserExists && !lmwUserExists.userVerified && lmwUserExists.attributes && lmwUserExists.attributes['custom:app'] === CUSTOM_APP.LMW;
}

export function userVerifiedViaLMW4(lmwUserExists: LmwUserExists): boolean {
  return lmwUserExists && lmwUserExists.userVerified && lmwUserExists.attributes && lmwUserExists.attributes['custom:app'] === CUSTOM_APP.LMW4;
}

export function userUnverifiedViaOCN(lmwUserExists: LmwUserExists): boolean {
  return lmwUserExists && !lmwUserExists.userVerified && lmwUserExists.attributes && lmwUserExists.attributes['custom:app'] === CUSTOM_APP.OCN;
}

export function userVerifiedViaOCN(lmwUserExists: LmwUserExists): boolean {
  return lmwUserExists && lmwUserExists.userVerified && lmwUserExists.attributes && lmwUserExists.attributes['custom:app'] === CUSTOM_APP.OCN;
}
